import { module } from 'modujs'
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import VueDatePicker from '@vuepic/vue-datepicker';

const API_BASE_URL = 'https://api.tripleseat.com/v1/leads/create.js?lead_form_id=29190&public_key=48efbd582548dd68dc164268f6a8cdbe0fed663c'

export default class extends module {
    constructor(m) {
        super(m)
    }

    init() {
        this.app = createApp({
            delimiters: [ '${', '}' ],
            components: {
                Datepicker: VueDatePicker
            },
            data: () => ({
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                date: null,
                guestCount: '',
                description: '',
                location: '',
                message: '',
                isSubmitted: false,
                isError: false
            }),
            methods: {
                getFormattedDate(date) {
                    const day = date.getDate()
                    const month = date.getMonth() + 1
                    const year = date.getFullYear()

                    return `${month}/${day}/${year}`
                },
                submit() {
                    this.resetStates()

                    if (!this.isValidForSubmission) {
                        this.showErrorMessage()
                        return false
                    }

                    this.message = 'Submitting...'

                    // Required fields
                    const query = new URL(API_BASE_URL)
                    query.searchParams.append('lead[first_name]', this.firstName)
                    query.searchParams.append('lead[last_name]', this.lastName)
                    query.searchParams.append('lead[email_address]', this.email)
                    query.searchParams.append('lead[phone_number]', this.phone)
                    query.searchParams.append('lead[event_date]', this.getFormattedDate(this.date))

                    // Optionnal fields
                    if (this.guestCount != null)  query.searchParams.append('lead[guest_count]', this.guestCount)
                    if (this.description != null)  query.searchParams.append('lead[event_description]', this.description)
                    if (this.location != null)  query.searchParams.append('lead[location]', this.location)

                    // Fetch url
                    fetch(query.href,
                        {
                            method: 'GET',
                            crossDomain: true,
                            credentials: 'same-origin',
                            mode: 'no-cors',
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                        .then(r => {
                            this.isSubmitted = true
                        })
                        .catch(e => {
                            this.message = 'An error happened, try again.'
                        }
                    )
                },
                showErrorMessage() {
                    this.isError = true
                    this.message = 'Please select a date'
                },
                resetStates() {
                    this.isError = false
                    this.message = ''
                },
                resetForm() {
                    this.isSubmitted = false
                    this.message = ''

                    requestAnimationFrame(() => {
                        this.$refs.form.reset()
                    })
                },
                onReceiveAttributes({ detail }) {
                    const { location } = detail
                    console.log('onReceiveAttributes', location)
                    this.location = location
                }
            },
            watch: {
                date(newDate, oldDate) {
                    if (newDate != null) this.resetStates()
                }
            },
            computed: {
                isValidForSubmission() {
                    return this.date != null
                },
            },
            mounted() {
                window.addEventListener('updateFormEventsAttributes', this.onReceiveAttributes);
            },
            beforeDestroy() {
                // Clean up the event listener when the component is destroyed
                window.removeEventListener('updateFormEventsAttributes', this.onReceiveAttributes);
            }
        }).mount(this.el)
    }
}
